import {
  api_react_v1_current_user_info_path,
  api_user_info_path,
  api_user_update_path,
} from '@routes';

import request from './request';

export const CURRENT_USER_KEY = 'CURRENT_USER_KEY';
export const NAV_CURRENT_USER_KEY = 'NAV_CURRENT_USER_KEY';

export enum CommentableType {
  ForumPost = 'ForumPost',
  Comment = 'Community::Comment',
}

export type User = {
  access_level: number;
  administrator: {
    is_active: boolean;
  };
  affiliate_code?: string;
  authenticated_by_jwt: boolean;
  can_actually_comment: boolean;
  can_initiate_mobile_subscription: boolean;
  can_update_payment: boolean;
  company_name: string | null;
  comped: boolean;
  email: string;
  guid: string;
  has_set_password: boolean;
  id: number;
  identity_id: number;
  is_corp_or_group_subscriber: boolean;
  is_free_edition_user: boolean;
  is_new_user: boolean;
  is_pro_subscriber: boolean;
  is_subscriber: boolean;
  login_link_only: boolean;
  name: string | null;
  one_line_bio: string | null;
  permitted_to_comment: boolean;
  picture_url: string | null;
  profile_enabled: boolean;
  referral_url: string;
  requires_name_to_comment: boolean;
  settings_access_obj: {
    gift_sub_access: boolean;
    privacy_access: boolean;
    referral_access: boolean;
    team_sub_access: boolean;
  };
  staff: boolean;
  subscription: {
    is_active: boolean;
    is_past_due: boolean;
    is_pro: boolean;
    plan_type: string;
    source: string;
  };
  stripe_customer_id: string;
  subscription_status: string;
  title_at_company: string | null;
  username: string;
};

export interface NavCurrentUser {
  isLoggedIn: boolean;
  isProSubscriber: boolean;
  isSubscriber: boolean;

  willSubscriptionChange: boolean;
  avatarUrl?: string;
  canViewGiftOption: boolean;
  profileCompletionPercentage: number;
  profileCompletionStatuses: { text: string; isComplete: boolean; href: string }[];
  username?: string;
  referralUrl?: string;
  planType?: string;
  initialSubscribeDateStr?: string;
}

export type NavProps = {
  isFullNav: boolean;
  isWebview: boolean;
  colorScheme: string;
  currentUser: NavCurrentUser;
  shouldOpenReferralModal: boolean;
  newForumPostsCount: number;
};

export type NavCurrentUserResponse = {
  navProps: NavProps;
};

// TODO: Adapt for other commentable types
export async function getCurrentUser(): Promise<User> {
  const resp = await request('get', api_user_info_path());
  return resp?.user;
}

export async function getNavCurrentUser(): Promise<NavCurrentUserResponse> {
  const resp = await request('get', api_react_v1_current_user_info_path());
  return resp;
}

export interface SanitizedUserParams {
  profile_enabled?: boolean;
  message_enabled?: boolean;
  title_at_company?: string;
  company_name?: string;
  name?: string;
  one_line_bio?: string;
}

export async function updateCurrentUser(values: SanitizedUserParams): Promise<{ user: User }> {
  const resp = await request('patch', api_user_update_path(values));
  return resp;
}
